import React from "react";

import styles from "./Section5.module.scss";

export const Section5 = function () {
  return (
    <section id="progOutline" className={`${styles.section5Wrapper} cc--component-container`}>
      <div className={styles.section5Container}>
        <div className={styles.section5Content}>
          <h3>COURSE CURRICULUM</h3>
          <span>Over the duration of this online program, you&rsquo;ll work through the following modules:</span>
          <div className={styles.rowContainer}>
            <div className={styles.firstCol}>
              <p>
                <strong>MODULE 1 The Landscape of Artificial Intelligence (AI) in the Pharmaceutical Industry</strong>
                <br />
                Gain insight into the present state of machine learning (ML) within the pharmaceutical industry.
              </p>
              <p>
                <strong>MODULE 2 Using AI for Early Drug Discovery: From Small Molecules to Biologics</strong>
                <br />
                Explore the molecular basis and biologic applications of ML for early drug discovery.
              </p>
              <p>
                <strong>MODULE 3 Modeling the Biological Underpinning of Disease</strong>
                <br />
                Learn about a common representation of biology and disease on a cellular level using AI.
              </p>
            </div>
            <div className={styles.secondCol}>
              <p>
                <strong>MODULE 4 Biomarkers, Discovery, and Patient Stratification</strong>
                <br />
                Consider how AI can assist with identifying biomarkers, disease tracking, and patient stratification.
              </p>
              <p>
                <strong>MODULE 5 Design and Management of Clinical Trials</strong>
                <br />
                Explore the impact of ML on the design and management of clinical trials.
              </p>
              <p>
                <strong>MODULE 6 Business and Innovation in Pharma</strong>
                <br />
                Consider the business implications of AI in pharma and biotech.
              </p>
            </div>
          </div>
          <p className={styles.note}>
            <small>
              <em>
                Please note that module titles and their contents are subject to change during course development.
              </em>
            </small>
          </p>
        </div>
      </div>
    </section>
  );
};
